module.exports = __webpack_public_path__ + "img/dhruba-kandel.18edeec1.jpg";